import { mergeClassName as e } from "../../utils/data.js";
import t from "./Typography.module.js";
import { jsx as n } from "react/jsx-runtime";
//#region lib/components/Typography/Typography.tsx
function r({ variant: r = "body-small", weight: i, children: a, className: o, paragraph: s, alignItems: c, style: l, ...u }) {
	let d = r.startsWith("display-"), f = r.startsWith("heading-"), p = i ?? (d || f ? "medium" : "regular"), m = e(t[r], t[p], c ? t.aligned : void 0, o), h = {
		alignItems: c,
		...l
	};
	switch (r) {
		case "display-extra-large":
		case "display-large":
		case "display-medium":
		case "display-small":
		case "heading-large":
		case "heading-medium":
		case "heading-small": return /* @__PURE__ */ n("div", {
			className: m,
			style: h,
			...u,
			children: a
		});
		default: return n(s ? "p" : "span", {
			className: m,
			style: h,
			...u,
			children: a
		});
	}
}
//#endregion
export { r as Typography };
